<template>
  <div class="border-gray-500 border border-solid w-full height-container rounded relative">
    <SidebarLeft></SidebarLeft>
    <SidebarRight></SidebarRight>
  </div>
</template>

<script>
import SidebarLeft from "./sidebarLeft.vue";
import SidebarRight from './sidebarRight.vue'

export default {
  components: {
    SidebarLeft,
    SidebarRight
  }
};
</script>

<style lang="scss" scoped>

.height-container {
  height: calc(100vh - 235px);
}

.border-gray-500 {
  border-color: #a0aec0;
}
</style>
